window.localUsabilityClickElements = {
  '#contentpane a:not([rel*="external"])': {
    // Interner Link im Contentpane
    'type': 'navigation',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#playerbar .audioplayer-control[data-action="play"][aria-pressed="false"]': {
    // Playerleiste: Play-Button
    'type': 'action',
    'click': 'Der Play-Button wurde betätigt',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': ''
  },
  '#playerbar .audioplayer-control[data-action="play"][aria-pressed="true"]': {
    // Playerleiste: Stopp-Button
    'type': 'action',
    'click': 'Der Stopp-Button wurde betätigt',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': ''
  },
  '#playerbar .audioplayer-control[data-action="livestream"][aria-pressed="false"]': {
    // Playerleiste: Livestream-Button
    'type': 'action',
    'click': 'Der Livestream-Button wurde betätigt',
    'click_chapter1': 'Playerleiste',
    'click_chapter3': '{ATTR-ARIA-LABEL}'
  },
  '#content .asset-audio .audioplayer-control[data-action="play"][aria-pressed="false"]': {
    // Inline-Audioplayer: Play-Button
    'type': 'action',
    'click': 'Der Play-Button wurde betätigt',
    'click_chapter1': 'Inline-Audioplayer',
    'click_chapter3': '{ATTR-ARIA-LABEL}'
  },
  '#content .asset-audio .audioplayer-control[data-action="play"][aria-pressed="true"]': {
    // Inline-Audioplayer: Stopp-Button
    'type': 'action',
    'click': 'Der Stopp-Button wurde betätigt',
    'click_chapter1': 'Inline-Audioplayer',
    'click_chapter3': '{ATTR-ARIA-LABEL}'
  },
  '#nowplaying .audioplayer-control[data-action="play"][aria-pressed="false"]': {
    // Hook-Player Contentpane
    'type': 'action',
    'click': 'Der Play-Button wurde betätigt',
    'click_chapter1': 'Hook Audioplayer',
    'click_chapter3': '{ATTR-ARIA-LABEL}'
  },
  '#nowplaying .audioplayer-control[data-action="play"][aria-pressed="true"]': {
    // Hook-Player Contentpane
    'type': 'action',
    'click': 'Der Stopp-Button wurde betätigt',
    'click_chapter1': 'Hook Audioplayer',
    'click_chapter3': '{ATTR-ARIA-LABEL}'
  },
  '#musikrecherche-playlist .audioplayer-control[data-action="play"][aria-pressed="false"]': {
    // Hook-Player Contentpane
    'type': 'action',
    'click': 'Der Play-Button wurde betätigt',
    'click_chapter1': 'Hook Audioplayer',
    'click_chapter3': '{ATTR-ARIA-LABEL}'
  },
  '#musikrecherche-playlist .audioplayer-control[data-action="play"][aria-pressed="true"]': {
    // Hook-Player Contentpane
    'type': 'action',
    'click': 'Der Stopp-Button wurde betätigt',
    'click_chapter1': 'Hook Audioplayer',
    'click_chapter3': '{ATTR-ARIA-LABEL}'
  },
  '#musikrecherche-playlist .btn.btn-secondary.btn-playlist-prev': {
    'type': 'navigation',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Musikrecherche',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#musikrecherche-playlist .btn.btn-secondary.btn-playlist-next': {
    'type': 'navigation',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Musikrecherche',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.sentiments .btn.btn-sentiment input[type=radio]': {
    // Reactions
    'type': 'action',
    'click': 'Reaction "{ATTR-ARIA-LABEL}"',
    'click_chapter1': 'Reactions',
    'click_chapter3': ''
  }
};
